import type { ActionCreator } from '@reduxjs/toolkit';
import type { UpdateStaffingCalendarYearAction } from '../types';

export const updateStaffingCalendarYear: ActionCreator<UpdateStaffingCalendarYearAction> = (value: string) => {
  return {
    type: 'UPDATE_STAFFING_CALENDAR_YEAR',
    staffingCalendarYear: value,
  };
};
